module.exports = __webpack_public_path__ + "img/liuxuan.3e55e166.png";